import quickFetch from 'quick-fetch';
import type { UserInfo } from 'hub-http/userInfo';

export type GetUserId = () => Promise<number | undefined>;

const AUTH_TIMEOUT_MS = 3000;

export const extractUserId = (info: UserInfo): number => info.user.user_id;

// Default provider: the login-verify request is already in flight during
// quickFetch bootstrap, so read the user id off afterAuth. Reject if auth never
// resolves within the timeout — callers skip the request rather than fetch
// unscoped (potentially wrong) data.
export const readUserIdFromAuth: GetUserId = () =>
  new Promise((resolve, reject) => {
    const timeout = setTimeout(
      () => reject(new Error('Timed out reading userId from auth')),
      AUTH_TIMEOUT_MS
    );
    quickFetch.afterAuth((auth) => {
      clearTimeout(timeout);
      resolve(auth?.user?.user_id);
    });
  });
